import operations from '@/lib/ondit/batch-operations.json'
import { OnditBlock } from '@/blocks/blocks/ondit'
import type { BlockConfig } from '@/blocks/types'

/** What a new node starts with: a safe empty run of its operation. */
const STARTING_INPUTS: Record<string, unknown> = {
  'reflow.batch': { locale: 'en' },
  'draft.batch': { pages: [], locale: 'en', quality: 'standard', daily: false },
  'publish.batch': { pages: [], locale: 'en', block_dirty_facts: true, before_batches: [] },
  'distribution.batch': { pages: [], channels: [], preset: 'portrait' },
}

/**
 * Each optimization batch operation is its own node with its own settings.
 * The operation is fixed by the block type — the executor reads it from
 * there — and the hidden `capability` field keeps it where the canvas and the
 * input form already look for it.
 */
export const OnditBatchOperations = Object.fromEntries(
  operations.map((operation) => {
    const type = `ondit_${operation.id.replace('.batch', '')}`
    const block: BlockConfig = {
      ...OnditBlock,
      type,
      name: operation.label[0],
      description: operation.label[0],
      subBlocks: OnditBlock.subBlocks.map((field) =>
        field.id === 'capability'
          ? {
              id: 'capability',
              title: '',
              type: 'short-input' as const,
              defaultValue: operation.id,
              hidden: true,
            }
          : field.id === 'inputs'
            ? { ...field, defaultValue: JSON.stringify(STARTING_INPUTS[operation.id] ?? {}) }
            : field
      ),
    }
    return [type, block]
  })
) as Record<string, BlockConfig>
